import HeroContainer from '../../components/Hero'
import TopSellers from '../../components/TopSellers'
import TopCollections from '../../components/TopCollections'
import ListedItems from '../../components/ListedItems'
import LiveAuctions from '../../components/LiveAuctions'
import Head from '../../layouts/Head';
import Footer from '../../layouts/Footer';
// import '../../assets/css/HomeDemo2.css'

const HomeDemo2 = () => {

  return (
    <>
      <Head Title='HomeDemo2' />
      <HeroContainer
        ClassDiv="hero-section demo-2 section-padding"
        addMoving={false}
        title="All NFTs You need in One Marketplace"
        textUp="The Best Place to Collect , Buy and Sell"
        SpanTex="Awesome NFTs"
        textDown="Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eveniet dolorem blanditiis ad perferendis, labore delectus dolor adipisicing elit sit amet, adipisicing elit. Eveniet adipisicing elit."
        linkUp="Explore More"
        linkDown="Collect NFT"
      />
      <TopCollections />
      <TopSellers />
      <ListedItems />
      <LiveAuctions />
      <Footer />
    </>
  );
}

export default HomeDemo2;